import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

import { TYPES } from '@antv/l7-core';
import Source, { DEFAULT_DATA, DEFAULT_PARSER } from '@antv/l7-source';
import { injectable } from 'inversify';
import 'reflect-metadata';
var DataSourcePlugin = (_dec = injectable(), _dec(_class = function () {
  function DataSourcePlugin() {
    _classCallCheck(this, DataSourcePlugin);

    _defineProperty(this, "mapService", void 0);
  }

  _createClass(DataSourcePlugin, [{
    key: "apply",
    value: function apply(layer) {
      var _this = this;

      this.mapService = layer.getContainer().get(TYPES.IMapService);
      layer.hooks.init.tap('DataSourcePlugin', function () {
        var source = layer.getSource();

        if (!source) {
          var _ref = layer.sourceOption || {
            data: DEFAULT_DATA,
            options: DEFAULT_PARSER
          },
              data = _ref.data,
              options = _ref.options;

          layer.setSource(new Source(data, options));
        }

        _this.updateClusterData(layer);
      });
      layer.hooks.beforeRenderData.tap('DataSourcePlugin', function () {
        var neeUpdateCluster = _this.updateClusterData(layer);

        var dataSourceNeedUpdate = layer.dataState.dataSourceNeedUpdate;
        layer.dataState.dataSourceNeedUpdate = false;
        return neeUpdateCluster || dataSourceNeedUpdate;
      });
    }
  }, {
    key: "updateClusterData",
    value: function updateClusterData(layer) {
      var source = layer.getSource();
      var cluster = source.cluster;
      var _source$clusterOption = source.clusterOptions,
          _source$clusterOption2 = _source$clusterOption.zoom,
          zoom = _source$clusterOption2 === void 0 ? 0 : _source$clusterOption2,
          _source$clusterOption3 = _source$clusterOption.maxZoom,
          maxZoom = _source$clusterOption3 === void 0 ? 16 : _source$clusterOption3;
      var newZoom = this.mapService.getZoom() - 1;
      var dataSourceNeedUpdate = layer.dataState.dataSourceNeedUpdate;

      if (cluster && (dataSourceNeedUpdate || Math.abs(zoom - newZoom) > 1) && maxZoom > zoom) {
        source.updateClusterData(Math.floor(newZoom));
        return true;
      }

      return false;
    }
  }]);

  return DataSourcePlugin;
}()) || _class);
export { DataSourcePlugin as default };
//# sourceMappingURL=DataSourcePlugin.js.map